import {
  DateTimeRangeFilter,
  TableActionMenu,
  UuidFilterInput,
  type TableActionItem,
} from '@/components/shared';

export interface UsersFiltersProps {
  organizationId: string;
  lastSeenFrom: string;
  lastSeenTo: string;
  createdFrom: string;
  createdTo: string;
  actions?: TableActionItem[];
  showOrganizationFilter?: boolean;
  onOrganizationIdChange: (value: string) => void;
  onLastSeenRangeChange: (lastSeenFrom: string, lastSeenTo: string) => void;
  onCreatedRangeChange: (createdFrom: string, createdTo: string) => void;
}

export function UsersFilters({
  organizationId,
  lastSeenFrom,
  lastSeenTo,
  createdFrom,
  createdTo,
  actions = [],
  showOrganizationFilter = true,
  onOrganizationIdChange,
  onLastSeenRangeChange,
  onCreatedRangeChange,
}: UsersFiltersProps) {
  return (
    <div className="flex flex-wrap items-end gap-3 border-b border-neutral-200 bg-neutral-50 px-5 py-4">
      {showOrganizationFilter && (
        <UuidFilterInput
          label="Organization"
          value={organizationId}
          onChange={onOrganizationIdChange}
          placeholder="Organization UUID"
          className="flex min-w-[260px] flex-col gap-1 text-small font-medium text-neutral-700"
        />
      )}

      <DateTimeRangeFilter
        label="Last seen online"
        from={lastSeenFrom}
        to={lastSeenTo}
        onRangeChange={onLastSeenRangeChange}
      />

      <DateTimeRangeFilter
        label="Created date"
        from={createdFrom}
        to={createdTo}
        onRangeChange={onCreatedRangeChange}
      />

      {actions.length > 0 && (
        <div className="flex w-full justify-end md:ml-auto md:min-w-[14rem] md:flex-1">
          <TableActionMenu
            actions={actions}
            label="User table actions"
            containerClassName="w-auto md:w-full"
          />
        </div>
      )}
    </div>
  );
}
